import React, {useEffect, useState} from 'react';
import {inject, observer} from "mobx-react";
import {formatDate, formatNumber, trans} from "../../../common/utils";
import cx from "classnames";


const winDate = (date) => {
    if (!date) return null;
    const parsed = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(parsed.getTime()) || parsed.getTime() <= 0) return null;
    return parsed;
};

const hasWinAmount = (value) => value !== null && value !== undefined;

const JackpotWinRow = ({ label, amount, date, currency, language, emphasize }) => {
    const shownDate = winDate(date);
    if (!hasWinAmount(amount) && !shownDate) return null;

    return (
        <p className="jackpot-group__details-row">
            <span className={cx('jackpot-group__details-label', emphasize && 'jackpot-group__details-row-info--first')}>
                {label}
            </span>
            {hasWinAmount(amount) ? (
                <span className={emphasize ? 'jackpot-group__details-row-info--first' : undefined}>
                    {formatNumber(amount, 2, language, currency)}
                </span>
            ) : null}
            {shownDate ? (
                <span className="jackpot-group__details-date">
                    {formatDate(shownDate, 'DD.MM.YY', language)}
                </span>
            ) : null}
        </p>
    );
};

const JackpotGroupCardItemDetails = (
    {
        info,
        type,
        currency,
        language
    }
) => (
    <div className={cx('jackpot-group__details', `jackpot-group__details--${type}`)}>
        <JackpotWinRow
            label={trans('JACKPOT_TOP_WIN')}
            amount={info.maxWinValue}
            date={info.maxWinDate}
            currency={currency}
            language={language}
            emphasize
        />
        <JackpotWinRow
            label={trans('JACKPOT_LAST_WIN')}
            amount={info.lastWinValue}
            date={info.lastWinDate}
            currency={currency}
            language={language}
        />
        {hasWinAmount(info.totalWins) ? (
            <p className="jackpot-group__details-totals">
                <span className="jackpot-group__details-label">{trans('JACKPOT_TOTAL_WINS')}: </span>
                <span>{info.totalWins}</span>
            </p>
        ) : null}
    </div>
);
const JackpotGroupDetailItem = (
    {
        store,
        jackpotId,
        type,
        withDetails = true,
        classPrefix = 'jackpot-group'
    }
) => {
    const jackpotGroupDetails = store.slotsCasinoGames.getJackpotGroupDetail({id: jackpotId});
    const language = store.user.language;

    const [value, setValue] = useState(0);
    const [change, setChange] = useState(false);

    useEffect(() => {
        if (jackpotGroupDetails) {
            if (!value) {
                setValue(jackpotGroupDetails[type].currentValue);
            } else {
                setTimeout(() => {
                    setValue(jackpotGroupDetails[type].currentValue);
                    setChange(v => !v);
                    setTimeout(() => setChange(v => !v), 500);
                }, Math.random() * 3000 + 1000)
            }
        }
    }, [jackpotGroupDetails && jackpotGroupDetails[type].currentValue]);

    return ((jackpotGroupDetails && jackpotGroupDetails[type] && jackpotGroupDetails[type].currentValue) ? <>
            <p className={`${classPrefix}__label ${classPrefix}__label--${type}`}>
                {trans(`${type.toUpperCase()}_JACKPOT`)}
            </p>
            <div className={`${classPrefix}__label-value ${classPrefix}__label-value--${type}`}>
                <span className={change ? `${classPrefix}__label-value-number` : ''}>
                    {formatNumber(value, 2, language, jackpotGroupDetails.currency)}
                </span>
                {withDetails && <JackpotGroupCardItemDetails
                    type={type}
                    info={jackpotGroupDetails[type]}
                    currency={jackpotGroupDetails.currency}
                    language={language}
                                />}
            </div>
        </> : null
    );
}

export default inject('store')(observer(JackpotGroupDetailItem));